module.exports = __webpack_public_path__ + "media/images/samples/300x300/2-9f53ee4a2fe2954f8381a8a08df479dc.jpg";